(function(){

  angular.module('irricrops')

/**
  * @ngdoc service
  * @name irricrops.menu
  * @module irricrops
  * @requires $location, $http, $state, urls, global, Config, CONSTANTES, $localStorage, $injector, $q
  * @description
  * Maneja las peticiones de /me y de /sidebar
  * anteriormente funcionaba a la par con sidebar, de ahi su nombre
  * actualmente es independiente de la directiva sidenav
  * TODO cambiar el nombre a profileFactory
  *
**/
  .factory('menu', [
      '$location',
      '$http',
      '$state',
      'urls',
      'global',
      'Config',
      'CONSTANTES',
      '$localStorage',
      '$injector',
      '$q',
      function ($location, $http,$state, urls, global, Config, CONSTANTES, $localStorage, $injector, $q) {

        var sections         = [];
        var self             = {};
        var sidebarDataDefer = $q.defer();
        global.sidebarData   = sidebarDataDefer.promise;
        var sidebarProm      = $q.defer();
        var meProm           = null;
        var allPromises = $q.defer();

         /**
           * @ngdoc method
           * @name irricrops.menu#getSidebar
           * @methodOf irricrops.menu
           * @description
           * Obtiene los datos para el sidebar
           * Redirecciona el estado actual 'initial' al estado inicial
           * seteado en CONSTANTES.INITIAL_STATE
           * setea el global.sidebar, global.title y Config.vinedo
           *
           * @param {Integer} user_id Id del usuario
           * @returns {promise} promise Promesa de peticion $http.get('/sidebar')
         **/
        function getSidebar(user_id, reload){
          var r = $http.get(urls.BASE+"/sidebar", {params:{user_id:user_id}});
                r.then(function(res){

                    global.sidebar = res.data.data;
                    //resuelve promesa sidebarProm
                    sidebarDataDefer.resolve(global.sidebar);

                    if (($state.current.name == "initial" && res.data.data.vinas.length > 0 &&
                        res.data.data.vinas[0].vinedos.length > 0) || reload) {
                      global.title = res.data.data.vinas[0].vinedos[0].name;
                      Config.vinedo = res.data.data.vinas[0].vinedos[0].config;

                      var isMobile = global.responsiveIs("xs, sm");
                      if(isMobile){
                        $state.go(CONSTANTES.INITIAL_MOBILE_STATE, {id: res.data.data.vinas[0].vinedos[0].id});
                        console.log("menu.js redirect mobile");
                      }else{
                        $state.go(CONSTANTES.INITIAL_STATE, {id: res.data.data.vinas[0].vinedos[0].id});
                        console.log("menu.js redirect");
                      }

                    }

                    //parse config de vinedo, de int/string a boolean
                    angular.forEach(Config.vinedo, function(item, index){
                      if (item == '1' || item === 1) {
                        Config.vinedo[index] = true;
                      }
                      if (item == '0' || item === 0) {
                        Config.vinedo[index] = false;
                      }
                    });

                  }, function () {

                  });

          return r;
        } //END getSidebar()


        /**
        * @ngdoc method
        * @name irricrops.menu#getMe
        * @methodOf irricrops.menu
        *
        * @description
        * Obtiene los datos del usuario
        * setea datos en angulartics, mixpanel y smartsupp
        * asigna datos en global.me y Config.user
        * ejecuta la funcion getSidebar asignando el resultado (promise) a sidebarProm
        *
        * en caso de error, redirige a state login
        *
        * @returns {promise} meProm devuelve la promesa de la peticion http.get('/me')
        **/
        function getMe(params) {
          if(meProm === null){
            meProm = $http.get(urls.BASE+"/me")
              .then(function(resMe){
              var d = resMe.data;
              if( angular.isDefined(resMe.headers()['authorization'] )){ //jshint ignore:line
                $localStorage.token = resMe.headers()['authorization'].split(' ')[1]; //jshint ignore:line
              }
              //angulartics y ga
              ga('set', '&uid', d.data.user.id); // Establezca el ID de usuario mediante el user_id con el que haya iniciado sesión.
              ga('set', 'dimension1', d.data.user.email);
              ga('set', 'dimension2', d.data.user.id);

              mixpanel.identify(d.data.user.id);
              mixpanel.people.set({
                "$name": d.data.user.name,
                "$email": d.data.user.email
              });

              //exception handler, envia señal a Sentry
              if(Raven){
                Raven.setTagsContext({
                  email : d.data.user.email,
                });

                Raven.setUserContext({
                  email : d.data.user.email,
                  id    : d.data.user.id,
                  username: d.data.user.name,
                });
              }

              global.me = d.data;
              Config.user = d.data.permisos;

              var forceReload = params ? !!params.reload : false;

                getSidebar(d.data.user.id, forceReload)
                  .then(function(resSidebar) {

                    allPromises.resolve({sidebar:resSidebar, me: resMe});
                    var vinasString = "";
                    if(resSidebar.data.data.vinas.length > 1){
                      vinasString = "Tiene "+resSidebar.data.data.vinas.length+" empresas asociadas";
                    }else if(resSidebar.data.data.vinas.length == 1){
                      vinasString = "("+resSidebar.data.data.vinas[0].id + ") - " + resSidebar.data.data.vinas[0].nombre;
                    }


                var slackData = {
                  "channel"  : "#irricrops-login",
                  "username" : "Irricrops Login",
                  "icon_url" : "https://legacy.irricrops.com/img/favicons/apple-touch-icon.png",
                  "attachments": [
                    {
                      "title"    : d.data.user.id+" - "+d.data.user.name,
                      "color": d.data.user.email.split("@irricrops.com").length > 1 ? "#388e3c":"#3AA3E3",
                      "attachment_type": "default",
                      "fields": [
                          {
                            "title": "Empresa",
                            "value": vinasString,
                            "short": true
                          },
                          {
                            "title": "email",
                            "value": d.data.user.email,
                            "short": true
                          }
                        ]
                    }]
                };


                if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                  slackData.username = "Irricrops Login Mobile";
                  //slackData.image_url =  "https://app.irricrops.com/img/favicons/apple-touch-icon.png",
                  delete slackData.image_url;
                  slackData.icon_emoji = ":iphone:";
                  slackData.attachments[0].fields.push({
                    "title" : "mobile phone",
                    "value" : navigator.userAgent,
                    "short" : false
                  });
                }

                if(window.location.hostname.split("irricrops.com").length > 1){
                  $http({
                    url    : 'https://hooks.slack.com/services/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',
                    method : "POST",
                    data   : JSON.stringify(slackData)
                  });
                  mixpanel.track("me", {});

                }
                sidebarProm.resolve(resSidebar);
              });
              }, function() {
              var $st = $injector.get('$state');
              if(["login", "aux"].indexOf($st.current.name) > -1){
                $st.go("login");
              }
              sidebarProm.reject(new Error('fail get sidebar'));
            });
          }
          return allPromises.promise;
        }//END getMe();




        /**
        * @ngdoc property
        * @name irricrops.menu#self
        * @propertyOf irricrops.menu
        *
        * @description
        * publica las funcion getMe,
        * las promesa sidebarProm
        * y la funcion showSidebar que verifica la existencia de sidebarProm
        *
        * TODO verificar funciones deprecadas
        **/
        self = {
          // //DEPRECATED
          // sections: sections,
          // //DEPRECATED
          // toggleSelectSection: function (section) {
          //   self.openedSection = (self.openedSection === section ? null : section);
          // },
          // //DEPRECATED
          // isSectionSelected: function (section) {
          //   return self.openedSection === section;
          // },
          clean: function () {
            meProm = null;
            sidebarProm = $q.defer();
            allPromises = $q.defer();
          },
          getSidebarProm : function () {
            return sidebarProm.promise;
          },
          showSidebar : function(){
            return sidebarProm.promise.$$state.status == 1; //1 == success
          },
          getMe: getMe,
        };

        return self;
      }]);



})();
